var map = {
	"./boredpanda/root-variables.css": [
		1292,
		9
	],
	"./delfi/root-variables.css": [
		1293,
		11
	],
	"./m360/root-variables.css": [
		1294,
		13
	],
	"./tvarilietuva/root-variables.css": [
		1295,
		39
	],
	"./verslas/root-variables.css": [
		1296,
		42
	],
	"./video/root-variables.css": [
		1297,
		43
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1079;
module.exports = webpackAsyncContext;